// *******~ Import ~******** //
// React
// Assets
// Components

// CSS
import "./help.scss";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";
// Images
import orderimg from "./icons/question-1.svg";
import validimg from "./icons/valid-2.svg";
import guid from "./icons/guide.svg";
import gift from "./icons/gift.png";
import React, { useState, useContext, useEffect } from "react";
import EmptyPage from "./empty-error-page";
import fulllist from "./search-data.json";
import HelpError from "./help-error";
import FreshchatWidget from "./chat";
import { OrderFlow } from "../../App";
import { Helmet } from "react-helmet";
import { getSeoDataApi } from "../../../src/api/seo/seo";
// Icons
import {
  MdOutlineArrowBackIos,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
// *******~ Import ~******** //
const Help = () => {
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;
  const [searchTerm, setSearchTerm] = useState("");
  const [matchedTopics, setMatchedTopics] = useState([]);
  const { setFooterLoading, footerLoading } = OrderFlow();
  useEffect(() => {
    // console.log(footerLoading);
    setFooterLoading(true);
  }, []);
  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);

    // Find all matching subtopics
    const matchingSubtopics = fulllist
      .flatMap((topic) => Object.values(topic)[0])
      .filter((subtopic) =>
        subtopic.title.toLowerCase().includes(newSearchTerm.toLowerCase())
      );

    setMatchedTopics(matchingSubtopics);
  };

  const [seoData, setSeoData] = useState(); // Initialize sitemap state to null
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767; useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  const navigateto = useNavigate();
  // if (!location.pathname?.includes("/myaccount") && width > breakpoint) {
  //   navigateto("/myaccount/addressaccount");
  // }
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiResponse = await getSeoDataApi();
        if (apiResponse?.data?.status === false) {
          // Handle error condition
          console.error(
            "Error fetching sitemap data:",
            apiResponse.data.message
          );
        } else {
          // Handle success condition
          setSeoData(apiResponse.data.message); // Update sitemap state with the fetched data
        }
      } catch (error) {
        console.error("Error fetching sitemap data:", error);
      }
    };

    fetchData(); // Call fetchData when the component mounts
  }, []); // Empty dependency array to ensure this effect runs only once
  const Imagetopdark = 'https://fusionbucket.co.uk/My-account/arrowwhitecolor.png';
  const Imagetop = 'https://fusionbucket.co.uk/Account-details /Arrow-final.png';
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        {seoData?.title?.Help ? (
          <title>{seoData.title.Help}</title>
        ) : (
          <title>Fusion Kitchen | Help</title>
        )}
      </Helmet>
      <Helmet>
        <meta name="robots" content={seoData?.meta?.Help?.robots} />
        <meta name="description" content={seoData?.meta?.Help?.description} />
        <meta name="keywords" content={seoData?.meta?.Help?.keywords} />
      </Helmet>
      {width > breakpoint ? (
        <section>
          {/* <h5 className='arrow-texthelp'> Help</h5> */}
          <div className="help_back">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <h2 className="help_name">
                    Having trouble? we're here to help
                  </h2>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-5 col-lg-5 col-md-5"></div>
                </div>
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="search_bar">
                      <input
                        type="text"
                        placeholder="Start typing your search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <span className="search_icon">
                        <AiOutlineSearch />
                      </span>
                    </div>

                    <h4 className="sub">Or choose an option below</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {searchTerm && matchedTopics.length === 0 ? (
            <>
              <HelpError />
            </>
          ) : null}
          {searchTerm && matchedTopics.length > 0 ? (
            <EmptyPage matchedTopics={matchedTopics} />
          ) : null}
          {(searchTerm && matchedTopics.length > 0) ||
            (searchTerm && matchedTopics.length === 0) ? null : (
            <>
              <div className="box_total">
                <div className="container">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/help-with-order">
                        <div className="order">
                          <img src={orderimg} alt="" />
                          <h5 className="box_name">Help with an order</h5>
                          <p className="box_sub">
                            Queries related to your orders <br /> can be solved
                            here
                          </p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/account-options">
                        <div className="order_same">
                          <img src={validimg} alt="" />
                          <h5 className="box_name">
                            Account and payment options
                          </h5>
                          <p className="box_sub">
                            View more on the list of solutions <br /> for payment
                            based queries
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/guide-fusion">
                        <div className="order_two ">
                          <img src={guid} alt="" />
                          <h5 className="box_name">Guide to Fusion Kitchen</h5>
                          <p className="box_sub">
                            Click to explore more about <br /> Fusion Kitchen
                          </p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/offer-information">
                        <div className="order_two">
                          <img src={gift} alt="" />
                          <h5 className="box_name">Other information</h5>
                          <p className="box_sub">
                            In case any other pieces of <br /> information are
                            needed
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <FreshchatWidget />
        </section>
      ) : (
        <section>
          <div className="arrow-texthelpdiv d-none">
            <h5 className='arrow-texthelp'>
              <MdOutlineArrowBackIos className='arrowtop-iconshelps' onClick={() => navigate('/myaccount')} />Help
            </h5>
          </div>
          <div className="help_back">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <h2 className="help_name">
                    Having trouble? we're here to help
                  </h2>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-5 col-lg-5 col-md-5"></div>
                </div>
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="search_bar">
                      <input
                        type="text"
                        placeholder="Start typing your search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <span className="search_icon">
                        <AiOutlineSearch />
                      </span>
                    </div>

                    <h4 className="sub">Or choose an option below</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {searchTerm && matchedTopics.length === 0 ? (
            <>
              <HelpError />
            </>
          ) : null}
          {searchTerm && matchedTopics.length > 0 ? (
            <EmptyPage matchedTopics={matchedTopics} />
          ) : null}

          {(searchTerm && matchedTopics.length > 0) ||
            (searchTerm && matchedTopics.length === 0) ? null : (
            <>
              <div className="box_total">
                <div className="container">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/help-with-order">
                        <div className="order">
                          <img src={orderimg} alt="" />
                          <h5 className="box_name">Help with an order</h5>
                          <p className="box_sub">
                            Queries related to your orders <br /> can be solved
                            here
                          </p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/account-options">
                        <div className="order_same">
                          <img src={validimg} alt="" />
                          <h5 className="box_name">
                            Account and payment options
                          </h5>
                          <p className="box_sub">
                            View more on the list of solutions <br /> for payment
                            based queries
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/guide-fusion">
                        <div className="order_two ">
                          <img src={guid} alt="" />
                          <h5 className="box_name">Guide to Fusion Kitchen</h5>
                          <p className="box_sub">
                            Click to explore more about <br /> Fusion Kitchen
                          </p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5">
                      <Link className="deco" to="/offer-information">
                        <div className="order_two">
                          <img src={gift} alt="" />
                          <h5 className="box_name">Other information</h5>
                          <p className="box_sub">
                            In case any other pieces of <br /> information are
                            needed
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <FreshchatWidget />
        </section>
      )}
    </>
  );
};
export default Help;
